import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { JhiEventManager } from 'ng-jhipster';
import { Subscription } from 'rxjs/Subscription';

import { ParamUtils, StateStorageService } from '../../shared';
import { LoginService, Principal } from '../../services';
import { ExternalAuthenticationData } from '../../models';
import { CAS_PG, AUTHENTICATION_SUCCESS } from '../../shared/constants';

@Component({
    selector: 'qms-home',
    templateUrl: './home.component.html'
})

export class HomeComponent implements OnInit, OnDestroy {
    private routeSubscription: Subscription;

    constructor(private principal: Principal,
                private eventManager: JhiEventManager,
                private stateStorageService: StateStorageService,
                private loginService: LoginService,
                private router: Router,
                private route: ActivatedRoute) {
    }

    ngOnInit() {
        this.routeSubscription = this.route.queryParams.subscribe((params) => {
            ParamUtils.parseString(params['ticket'], (ticket: string) => {
                // If ticket was provided -> external login
                this.login(ticket);
            });
        });
    }

    public isAuthenticated() {
        return this.principal.isAuthenticated();
    }

    ngOnDestroy() {
        if (this.routeSubscription) {
            this.routeSubscription.unsubscribe();
        }
    }

    private login(ticket: string) {
        // TODO: Enable after logout CUI session
        this.router.navigate(['']); // TODO: temp solution
        // const data = new ExternalAuthenticationData(CAS_PG, ticket);
        // this.loginService.loginExternal(data).then(() => {
        //
        //     this.eventManager.broadcast({
        //         name: AUTHENTICATION_SUCCESS,
        //         content: 'Sending Authentication Success'
        //     });
        //
        //     const redirect = this.stateStorageService.getUrl();
        //     if (redirect) {
        //         this.router.navigate([redirect]);
        //     } else {
        //         this.router.navigate(['']);
        //     }
        // });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/home/home.component.ts